import React from 'react';
import AboutHero from './AboutHero';
import AboutWhoWeAre from './AboutWhoWeAre';
import AboutStats from './AboutStats';
import AboutVisionMission from './AboutVisionMission';
import AboutValues from './AboutValues';
import AboutBanner from './AboutBanner';
import CTABanner from '../../components/CTABanner';
import { useSEO } from '../../hooks/useSEO';

const About: React.FC = () => {
  useSEO({
    title: 'About Us',
    description: 'Learn about Manlab Medicals Incorporated. Our mission is to be the most trusted and efficient medical supplies company in sub-Saharan Africa.',
    canonical: '/about'
  });

  return (
    <main className="pt-0">
      <AboutHero />
      <AboutWhoWeAre />
      <AboutStats />
      <AboutVisionMission />
      <AboutValues />
      <AboutBanner />
      <CTABanner />
    </main>
  );
};

export default About;
